import { useNavigate } from 'react-router-dom';

import { LoginForm } from '../components/LoginForm';
import { WebLayout } from 'components/Layout';

export const Login = () => {
  const navigate = useNavigate();

  return (
    <WebLayout>
      <LoginForm onSuccess={() => navigate('/app')} />
    </WebLayout>
  );
};
